import React from 'react';
import { Row, Col, Image, Form, InputGroup } from 'react-bootstrap';
import { Field, Formik, Form as FormikForm } from 'formik';
import RegistrationActionButton from '../../../components/RegistrationActionButton';
import logo from '../../../assets/images/job-portal/zestur-logo-internal.svg';
import { ASSETS_URL } from '../../../constants';
import { backgroundImage } from '../../../utils/AppConstants';
import { useDispatch, useSelector } from 'react-redux';
import Step from '../../../models/step.interface';
import { AppDispatch, RootState } from '../../../store/store';
import { object, string } from 'yup';
import { setCompanyAddress } from '../../../store/slices/companySlice';
import { useTranslation } from 'react-i18next';
import RestrictedInput from '../../../components/ui/restricted-input/RestrictedInput';
import ProgressBarTitle from '../../../components/ui/progress-bar-title/ProgressBarTitle';
import MobileProgress from '../../../components/mobile-progress/MobileProgress';
import {useNavigate} from "react-router-dom";
import Map from "../../../components/autocomplete/AddressAutocomplete";

function RegistrationStep2(props: Step) {
  const { t } = useTranslation();
  const company = useSelector((state: RootState) => state.companyReducer);
  const dispatch = useDispatch<AppDispatch>();
  const logoURL: string = `${ASSETS_URL}`;
  const navigate = useNavigate();

  const validationSchema = object({
    address: string().required(t('errors.fieldRequired')),
    address_number: string().required(t('errors.fieldRequired')),
    address_stair: string().required(t('errors.fieldRequired')),
    city: string().required(t('errors.fieldRequired')),
    country: string().required(t('errors.fieldRequired')),
  });

  return (
    <div className='register-form'>
      <Row>
        <Col xs={12} className='no-mobile-hidden'>
          <MobileProgress
            data={props}
            progressValue={40}
            startStep={2}
            endStep={5}
          />
        </Col>

        <Col
          xs={12}
          md={9}
          lg={10}
          className='d-flex justify-content-center justify-items-center'
          style={{margin:"0 auto"}}
        >
          <div className='company-register-logo'>
            <Image src={ASSETS_URL + logo} alt='logo Image' fluid onClick={() => navigate('/')} />
          </div>
          <Formik
            initialValues={{
              address: company.address,
              address_number: company.address_number,
              address_stair: company.address_stair,
              address_floor: company.address_floor,
              city: company.city,
              country: company.country,
              latitude: company.latitude,
              longitude: company.longitude,
            }}
            onSubmit={(values) => {
              dispatch(setCompanyAddress(values));
              props.handleNext();
            }}
            validationSchema={validationSchema}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <FormikForm className='bg-blue-gradient form w-100 d-flex justify-content-evenly flex-column'>
                <div className='main-ProgressBar mobile-hidden'>
                  <ProgressBarTitle
                    startStep={2}
                    endStep={5}
                    progressValue={34}
                  />
                </div>
                {/* form-fields */}
                <Row className='form-fields candidate'>
                  <h2 className='text-main-black px-4'>
                    {t('companyRegistration.step1.title')}{' '}
                  </h2>
                  <Row>
                      <Map
                          initialText={values.address ?? ""}
                          country="es"
                          minLength={3}
                          debounceMs={300}
                          onSelect={(a) => {
                              // push selected values into Formik state
                              setFieldValue("address", a.street ?? "");
                              setFieldValue("address_number", a.houseNumber ?? "");
                              setFieldValue("city", a.city ?? "");
                              setFieldValue("country", a.country ?? "");
                              setFieldValue("address_stair", a.postalCode ?? "");
                              setFieldValue("latitude", a.lat ?? null);
                              setFieldValue("longitude", a.lng ?? null);
                          }}
                      />
                  </Row>
                  <Row>
                    <Form.Group
                      as={Col}
                      md={8}
                      xs={12}
                      controlId='validationCustom01'
                    >
                      <Form.Label className='label'>
                        {t('companyRegistration.step2.addressLabel')}
                      </Form.Label>
                      <InputGroup hasValidation>
                        <Field
                          className='form-control mt-2 px-4 py-3'
                          type='text'
                          placeholder=''
                          aria-describedby='inputGroupPrepend'
                          name='address'
                          id='address1Field'
                        />
                        {errors.address && touched.address ? (
                          <p className='text-danger position-absolute error-message candidate'>
                            {errors.address}
                          </p>
                        ) : null}
                      </InputGroup>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md={4}
                      xs={12}
                      controlId='validationCustom02'
                      className='mobile-mt-2'
                    >
                      <Form.Label className='label'>
                        {t('companyRegistration.step2.addressNumberLabel')}
                      </Form.Label>
                      <InputGroup hasValidation>
                        <Field>
                          {() => (
                            <RestrictedInput
                              setFieldValue={setFieldValue}
                              fieldValue={values.address_number}
                              valueName='address_number'
                              restriction='number'
                              id="address_number"
                            />
                          )}
                        </Field>
                        {errors.address_number && touched.address_number ? (
                          <p className='text-danger position-absolute error-message candidate'>
                            {errors.address_number}
                          </p>
                        ) : null}
                      </InputGroup>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      as={Col}
                      md={4}
                      xs={12}
                      controlId='validationCustom03'
                      className='mobile-mt-2'
                    >
                      <Form.Label className='label'>
                        {t('companyRegistration.step2.addressFloorLabel')}
                      </Form.Label>
                      <InputGroup hasValidation>
                        <Field
                          className='form-control mt-2 px-4 py-3'
                          type='text'
                          placeholder=''
                          aria-describedby='inputGroupPrepend'
                          name='address_floor'
                          id='address_floor'
                        />
                      </InputGroup>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      md={4}
                      xs={12}
                      controlId='validationCustom03'
                      className='mobile-mt-2'
                    >
                      <Form.Label className='label'>
                        {t('companyRegistration.step2.addressStairLabel')}
                      </Form.Label>
                      <InputGroup hasValidation>
                        <Field
                          className='form-control mt-2 px-4 py-3'
                          type='text'
                          placeholder=''
                          aria-describedby='inputGroupPrepend'
                          name='address_stair'
                          id='address_stair'
                        />
                        {errors.address_stair && touched.address_stair ? (
                          <p className='text-danger position-absolute error-message candidate'>
                            {errors.address_stair}
                          </p>
                        ) : null}
                      </InputGroup>
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      md={4}
                      xs={12}
                      controlId='validationCustom01'
                      className='mobile-mt-2'
                    >
                      <Form.Label className='label'>
                        {t('companyRegistration.step2.cityLabel')}
                      </Form.Label>
                      <InputGroup hasValidation>
                        <Field>
                          {() => (
                            <RestrictedInput
                              setFieldValue={setFieldValue}
                              fieldValue={values.city}
                              valueName='city'
                              restriction='text'
                              id="city"
                            />
                          )}
                        </Field>
                        {errors.city && touched.city ? (
                          <p className='text-danger position-absolute error-message candidate'>
                            {errors.city}
                          </p>
                        ) : null}
                      </InputGroup>
                    </Form.Group>
                  </Row>

                  <Row>
                    <Form.Group as={Col} md={4} xs={12} className='mobile-mt-2'>
                      <Form.Label className='label'>
                        {t('candidateRegistration.step1.regionLabel')}
                      </Form.Label>
                      <InputGroup hasValidation>
                        <Field>
                          {() => (
                            <RestrictedInput
                              setFieldValue={setFieldValue}
                              fieldValue={values.country}
                              valueName='country'
                              restriction='text'
                              id="country"
                            />
                          )}
                        </Field>
                        {errors.country && touched.country ? (
                          <p className='text-danger position-absolute error-message candidate'>
                            {errors.country}
                          </p>
                        ) : null}
                      </InputGroup>
                    </Form.Group>
                  </Row>
                </Row>
                <Row className='mt-4 no-mobile-hidden'></Row>
                <RegistrationActionButton
                  data={props}
                  isSubmit={true}
                ></RegistrationActionButton>
              </FormikForm>
            )}
          </Formik>
        </Col>
      </Row>
    </div>
  );
}

export default RegistrationStep2;
